import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import Header from '../components/Header/Header'
import { useSearchIpAddressMutation } from '../../../services'
import { UspConfigurationIpAddressViewResult } from '../../../models'
import AdminIPAddressesTable from './components/AdminIPAddressesTable'
import AddEditIpAddressesModal from './components/AddEditIpAddressesModal'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import { Button, Card, Container, Grid } from '@mui/material'
import Iconify from '../../../components/iconify'

const SettingsAdminIPAddresses = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchIPAddresses, { data, isLoading }] = useSearchIpAddressMutation()
  const [ipAddressesData, setIpAddressesData] = useState<UspConfigurationIpAddressViewResult[]>([])

  const handleSubmit = (values?: any) => {
    searchIPAddresses({
      simpleSearch: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setIpAddressesData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='IP Addresses'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <Button onClick={() => handleOpenModal()} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
            Add new
          </Button>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12} alignItems={'center'}>
                    <Header submit={submit} title='IP Addresses' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <AdminIPAddressesTable
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                      handleOpenModal={handleOpenModal}
                      loading={isLoading}
                      data={ipAddressesData}
                      setData={setIpAddressesData}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditIpAddressesModal
              submit={submit}
              open={openAddEditModal}
              onClose={handleCloseModal}
              type={type}
              rowData={rowData as UspConfigurationIpAddressViewResult}
            />
          </>
        )}
      </Form>
    </Container>
  )
}

export default SettingsAdminIPAddresses
